module.exports = __webpack_public_path__ + "media/bootstrap-icons/star-2335f4d1.svg";